import { getConfigValue } from "@iloq/shared-react/config";

// Shim for the core/shared config, to avoid changes in Vue components
export default {
  get: getConfigValue,
};
